import { useOffline } from "@/contexts/OfflineContext";
import { WifiOff, RefreshCw, CloudUpload, Check } from "lucide-react";

export function OfflineBanner() {
  const { isOnline, queueLength, syncing, syncQueue, lastSyncResult } = useOffline();

  if (isOnline && queueLength === 0 && !lastSyncResult) return null;

  return (
    <div
      className={`fixed bottom-4 left-4 z-50 flex items-center gap-3 px-4 py-2.5 rounded-lg shadow-lg text-sm font-medium transition-all ${
        !isOnline
          ? "bg-orange-500/90 text-white"
          : syncing
          ? "bg-blue-500/90 text-white"
          : queueLength > 0
          ? "bg-amber-500/90 text-white"
          : "bg-emerald-500/90 text-white"
      }`}
      data-testid="offline-banner"
    >
      {!isOnline ? (
        <>
          <WifiOff className="h-4 w-4" />
          <span>Offline — {queueLength} event{queueLength !== 1 ? "s" : ""} queued</span>
        </>
      ) : syncing ? (
        <>
          <RefreshCw className="h-4 w-4 animate-spin" />
          <span>Syncing {queueLength} event{queueLength !== 1 ? "s" : ""}...</span>
        </>
      ) : queueLength > 0 ? (
        <>
          <CloudUpload className="h-4 w-4" />
          <span>{queueLength} pending</span>
          <button
            onClick={syncQueue}
            className="ml-1 underline underline-offset-2 hover:opacity-80"
            data-testid="manual-sync-btn"
          >
            Sync now
          </button>
        </>
      ) : lastSyncResult ? (
        <>
          <Check className="h-4 w-4" />
          <span>Synced {lastSyncResult.synced} event{lastSyncResult.synced !== 1 ? "s" : ""}{lastSyncResult.failed > 0 ? ` (${lastSyncResult.failed} failed)` : ""}</span>
        </>
      ) : null}
    </div>
  );
}
